/**
 * Utilidades centrales de sanitización y escape HTML para prevención de XSS (CWE-79).
 * spec/05-security.md §4.5, spec/07-deployment.md §3.
 *
 * Garantiza que ningún dato controlado por usuario, proveedor externo o mensaje
 * de error pueda ser interpretado como código HTML ejecutable por el navegador.
 */

const HTML_ESCAPE_MAP: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const HTML_ESCAPE_REGEX = /[&<>"']/g;

/**
 * Escapa caracteres especiales en cadenas de texto para inserción segura en contenido HTML.
 * Convierte &, <, >, ", ' a sus respectivas entidades HTML seguras.
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value).replace(HTML_ESCAPE_REGEX, (char) => HTML_ESCAPE_MAP[char] ?? char);
}

/**
 * Escapa valores para inserción segura dentro de atributos HTML delimitados por comillas.
 */
export function escapeAttr(value: unknown): string {
  return escapeHtml(value);
}
